;(function () {
	const initCarousel = () => {
		document.querySelectorAll('[data-gallery-carousel]').forEach((root) => {
			if (root.dataset.galleryCarouselStarted === 'true') {
				return
			}
			root.dataset.galleryCarouselStarted = 'true'

			const swiperEl = root.querySelector('.gallery-carousel__swiper')
			if (!swiperEl || typeof Swiper === 'undefined') {
				return
			}

			const speed = Number(root.dataset.speed) * 1000
			const slidesPerView = root.dataset.slidesPerView || 'auto'
			const isAuto = slidesPerView === 'auto'
			const spaceBetween = Number(root.dataset.spaceBetween ?? 8)
			const slideCount = swiperEl.querySelectorAll('.swiper-slide').length

			// Loop needs enough source slides; with slidesPerView: 'auto' Swiper also
			// requires an explicit loopedSlides count or the marquee can stay stuck.
			const minSlidesForLoop = isAuto
				? 2
				: Math.max(2, Math.ceil(parseFloat(slidesPerView)) + 1)
			const canLoop = slideCount >= minSlidesForLoop

			const swiperParams = {
				loop: canLoop,
				speed,
				allowTouchMove: true,
				longSwipesRatio: 0.1,
				spaceBetween,
				autoplay: {
					delay: 1,
					disableOnInteraction: false,
				},
			}

			if (canLoop) {
				swiperParams.loopedSlides = slideCount
				swiperParams.loopAdditionalSlides = slideCount
			}

			if (isAuto) {
				swiperParams.slidesPerView = 'auto'
				swiperParams.breakpoints = {
					750: {
						spaceBetween,
					},
				}
			} else {
				const mobileSlides = parseFloat(slidesPerView)
				const desktopSlides = parseFloat(
					root.dataset.slidesPerViewDesktop || slidesPerView
				)

				swiperParams.slidesPerView = mobileSlides
				swiperParams.breakpoints = {
					750: {
						slidesPerView: desktopSlides,
						spaceBetween,
					},
				}
			}

			let swiper = null
			let duration
			let distanceRatio
			let startTimer
			let isPlaying = true
			let isReady = false

			const images = () => [...root.querySelectorAll('img')]

			const waitForImages = (callback) => {
				let settled = false
				const finish = () => {
					if (settled) return
					settled = true
					callback()
				}

				const imgs = images()
				if (imgs.length === 0) {
					finish()
					return
				}

				let remaining = 0
				imgs.forEach((img) => {
					// Treat broken images (complete + naturalWidth 0) as settled so a
					// single failed load cannot block Swiper forever.
					if (img.complete) return
					remaining += 1
					const onSettle = () => {
						remaining -= 1
						if (remaining <= 0) finish()
					}
					img.addEventListener('load', onSettle, { once: true })
					img.addEventListener('error', onSettle, { once: true })
				})

				if (remaining === 0) {
					finish()
					return
				}

				// Lazy / off-screen images may never fire; don't block the marquee.
				setTimeout(finish, 2000)
			}

			const startAutoplay = (delay = duration) => {
				if (!swiper || !isPlaying) return
				if (startTimer) clearTimeout(startTimer)
				startTimer = setTimeout(() => {
					if (swiper?.autoplay && isPlaying) {
						swiper.autoplay.start()
					}
				}, delay)
			}

			const stopAutoplay = () => {
				if (!swiper || !swiper.slides || swiper.slides.length === 0) {
					return
				}
				if (startTimer) clearTimeout(startTimer)
				swiper.setTranslate(swiper.getTranslate())
				const currentSlideWidth = swiper.slides[swiper.activeIndex].offsetWidth
				distanceRatio = Math.abs(
					(currentSlideWidth * swiper.activeIndex + swiper.getTranslate()) /
						currentSlideWidth
				)

				duration = swiper.params.speed * distanceRatio
				swiper.autoplay.stop()
			}

			const mountSwiper = () => {
				if (swiper) {
					return
				}

				swiper = new Swiper(swiperEl, swiperParams)
				isReady = true

				if (isPlaying) {
					swiper.autoplay.start()
				}

				// slidesPerView: 'auto' depends on intrinsic widths — refresh if
				// images finish after the timeout fallback mounted early.
				images().forEach((img) => {
					if (img.complete) return
					img.addEventListener(
						'load',
						() => {
							swiper?.update()
						},
						{ once: true }
					)
				})
			}

			const tryMount = () => {
				waitForImages(mountSwiper)
			}

			const visibilityObserver = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (entry.isIntersecting) {
							tryMount()
							if (isReady && isPlaying && swiper?.autoplay?.running === false) {
								swiper.update()
								swiper.autoplay.start()
							}
						}
					})
				},
				{ threshold: 0, rootMargin: '200px 0px' }
			)
			visibilityObserver.observe(root)

			document.addEventListener('visibilitychange', () => {
				if (!document.hidden && isReady && isPlaying) {
					swiper?.update()
					swiper?.autoplay?.start()
				}
			})

			const toggleEl = root.querySelector('.gallery-carousel_stop')
			if (!toggleEl) {
				return
			}

			let clickable = true
			const handleTogglePlay = () => {
				if (!isReady || !swiper || !swiper.slides || swiper.slides.length === 0) {
					return
				}
				if (!clickable) return
				clickable = false

				if (isPlaying) stopAutoplay()
				else {
					const distance =
						swiper.width * swiper.activeIndex + swiper.getTranslate()

					duration = distance !== 0 ? duration : 0
					swiper.slideTo(swiper.activeIndex, duration)
					startAutoplay()
				}
				isPlaying = !isPlaying
				if (isPlaying) toggleEl.classList.remove('gallery-carousel_stop_active')
				else toggleEl.classList.add('gallery-carousel_stop_active')
				setTimeout(() => {
					clickable = true
				}, 200)
			}

			toggleEl.addEventListener('click', handleTogglePlay)
		})
	}

	document.addEventListener('DOMContentLoaded', function () {
		initCarousel()
		document.addEventListener('shopify:section:load', function () {
			initCarousel()
		})
	})
})()
